module.exports = __webpack_public_path__ + "media/images/horizontal-e029160280f2a924a8d6ee41cbfea7c9.png";